import React from 'react';
import {
  Card, CardContent, CardLayout, Link,
} from '@americanexpress/dls-react';
import { IconGuide } from '@americanexpress/dls-icons';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styles from '../InspirationArticles.scss';
import { getInspiredExploreMoreUrlSelector } from '../../../selectors/getUrlSelectors';

export const ExploreMoreInspirationCard = ({ triggerOnClickAnalytics }) => {
  const exploreMoreUrl = useSelector(getInspiredExploreMoreUrlSelector);
  const { formatMessage } = useIntl();

  return (
    <Card className="height-full pad-0">
      <CardLayout className="pad-3-lr pad-2-b flex-item-grow">
        <CardContent
          className="text-wrap pad-0-tb flex-item-grow"
        >
          <div className={styles.customIconSize}>
            <IconGuide size="xl" className="height-full pad-2-t" />
          </div>
          <div>
            <p className="text-typography-body-2 color-typography-primary margin-0-b">
              {formatMessage({ id: 'getInspired.exploreMoreBody' })}
            </p>
          </div>
          <div className="pad-3-b pad-3-r position-absolute-br">
            <Link
              variant="primary"
              href={exploreMoreUrl}
              className="text-typography-body-2 font-weight-medium"
              onClick={async (e) => {
                e.stopPropagation();
                await triggerOnClickAnalytics('explore-more-inspiration-card');
              }}
            >
              {formatMessage({ id: 'getInspired.exploreMoreLink' })}
            </Link>
          </div>
        </CardContent>
      </CardLayout>
    </Card>
  );
};

ExploreMoreInspirationCard.propTypes = {
  triggerOnClickAnalytics: PropTypes.func,
};
